import {Component, Input, OnInit} from '@angular/core';
import {IInvitation} from '@app/models/signup';
import {Select} from "@ngxs/store";
import {CartState} from "@app/store/state/cart.state";
import {Observable} from "rxjs";
import {Account} from "@app/models/account";
import {take} from "rxjs/operators";

@Component({
  selector: 'app-header-invitation-b2b-partnership-logos',
  templateUrl: './header-invitation-b2b-partnership-logos.component.html',
  styleUrls: ['./header-invitation-b2b-partnership-logos.component.scss']
})
export class HeaderInvitationB2bPartnershipLogosComponent implements OnInit {

  @Select(CartState.accounts)
  accounts$: Observable<Account[]>;

  currentAccountLogo: string;

  @Input() invitation: IInvitation;
  @Input() isSuccess = false;
  @Input() iconType = 'link';
  @Input() onlyPartner = false;
  @Input() onlyClient = false;
  @Input() isInverted = false;

  get partnerHasLogo(): boolean {
    return Boolean(this.invitation.extras?.partner?.image);
  }

  get partnerLogo(): string {
    return this.partnerHasLogo ? this.invitation.extras?.partner?.image : '/assets/images/partner/partners_icon.svg';
  }

  get partnerLogoAsCssUrl(): string {
    return `url(${this.partnerLogo})`;
  }

  get clientHasLogo(): boolean {
    return Boolean(this.invitation.account?.logo);
  }

  get clientLogo(): string {
    /**
     * @deprecated we should use this.currentAccountLogo as it reflects better the used
     */
    return this.clientHasLogo ? this.invitation.account.logo : '/assets/images/partner/client_icon.svg';
  }

  get clientLogoAsCssUrl(): string {
    return `url(${this.currentAccountLogo || this.clientLogo})`;
  }

  ngOnInit(): void {
    this.accounts$.pipe(take(1)).subscribe(accounts => {
      const currentAccountLogo = accounts?.find(account => account?.id === window['CURRENT_ACCOUNT']?.id)?.logo;
      this.currentAccountLogo = currentAccountLogo && currentAccountLogo !== '' ? currentAccountLogo : '/assets/images/partner/client_icon.svg';
    })
  }
}
